/**
 * @license
 *
 * Copyright IBM Corp. 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Type of the Grid Mode
 */
export enum GRID_MODE {
  /**
   * Default grid with 32px gutter
   */
  DEFAULT = 'default',

  /**
   * Narrow 16px gutter
   */
  NARROW = 'narrow',

  /**
   * Condensed 1px border
   */
  CONDENSED = 'condensed',
}
